import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../components/AppShell";
import { Button } from "../components/ui/button";
import { CircleSlash } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="wizard-shell">
      <div className="wizard-frame fade-in">
        <header className="px-5 py-4 border-b border-slate-100">
          <Logo size={32} withWordmark />
        </header>
        <main className="flex-1 flex flex-col px-6 py-8 items-center justify-center text-center">
          <div className="h-16 w-16 rounded-full bg-slate-100 text-slate-700 flex items-center justify-center">
            <CircleSlash className="w-9 h-9" />
          </div>
          <h1 className="mt-5 text-2xl font-[Outfit] font-extrabold text-slate-900">
            Pago cancelado
          </h1>
          <p className="mt-2 text-sm text-slate-600 max-w-[22rem]">
            No se realizó ningún cargo. Puedes volver a intentar o enviar tu solicitud sin pagar ahora.
          </p>
          <div className="mt-6 w-full space-y-2.5">
            <Button onClick={() => navigate("/onboarding")}
              className="btn-primary h-12 w-full rounded-2xl font-semibold">
              Reintentar
            </Button>
            <button onClick={() => navigate("/")}
              className="h-11 w-full rounded-2xl border border-slate-200 text-sm font-semibold hover:bg-slate-50">
              Volver al inicio
            </button>
          </div>
        </main>
      </div>
    </div>
  );
}
